import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { createPerformanceSpans } from '../util/createPerformanceSpans.js';
import { shouldFilterRequest } from '../util/shouldFilterRequest.js'; // From sentry-javascript
// e.g. https://github.com/getsentry/sentry-javascript/blob/c7fc025bf9fa8c073fdb56351808ce53909fbe45/packages/utils/src/instrument.ts#L180

function handleXhr(handlerData) {
  if (handlerData.xhr.__sentry_own_request__) {
    // Taken from sentry-javascript
    // Only capture non-sentry requests
    return null;
  }

  if (handlerData.startTimestamp) {
    // TODO: See if this is still needed
    handlerData.xhr.__sentry_xhr__ = handlerData.xhr.__sentry_xhr__ || {};
    handlerData.xhr.__sentry_xhr__.startTimestamp = handlerData.startTimestamp;
  }

  if (!handlerData.endTimestamp) {
    return null;
  }

  var _ref = handlerData.xhr.__sentry_xhr__ || {},
      method = _ref.method,
      url = _ref.url,
      statusCode = _ref.status_code;

  if (url === undefined) {
    return null;
  }

  return {
    type: 'resource.xhr',
    name: url,
    start: (_optionalChain([handlerData, 'access', function (_) {
      return _.xhr;
    }, 'access', function (_2) {
      return _2.__sentry_xhr__;
    }, 'optionalAccess', function (_3) {
      return _3.startTimestamp;
    }]) || 0) / 1000 || handlerData.endTimestamp / 1000.0,
    end: handlerData.endTimestamp / 1000.0,
    data: {
      method: method,
      statusCode: statusCode
    }
  };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */


function handleXhrSpanListener(replay) {
  return function (handlerData) {
    if (!replay.isEnabled()) {
      return;
    }

    var result = handleXhr(handlerData);

    if (result === null) {
      return;
    }

    if (shouldFilterRequest(replay, result.name)) {
      return;
    }

    replay.addUpdate(function () {
      createPerformanceSpans(replay, [result]); // Returning true will cause `addUpdate` to not flush
      // We do not want network requests to cause a flush. This will prevent
      // recurring/polling requests from keeping the replay session alive.

      return true;
    });
  };
}

export { handleXhrSpanListener };